<template>
  <div class="animated fadeIn">
    <br />
    <spinner v-if="loading == true"></spinner>
    <div v-if="loading == false">
        <b-col sm="12">
            <b-alert variant="primary" show class="text-center"><h5>{{getEbookPriceText()}}</h5></b-alert> 
        </b-col>
        <div v-for="ebook in ebooks" :key="ebook._id">
            <div v-if="!ebook.hidden" style="margin-top: 10px;">
                <b-card header-tag="header" style="background-color: #c9e7f1;">
                <b-card-body>
                    <b-row>
                        <b-col sm="2" class="text-center">
                            <img :src="ebook.cover" style="max-width: 160px;"/>
                        </b-col>
                        <b-col sm="6">
                            <b-row>
                                <b-col>
                                    <h2>{{ebook.name}}</h2>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <p class="lead my-4">
                                        {{ebook.description}}
                                    </p>
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="(item, index) in ebook.items" :key="index" class="py-2">
                                            <div class="d-flex align-items-center">
                                                <div>
                                                    <b-badge v-b-tooltip.hover variant="success" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-book"></i></b-badge>
                                                </div>
                                                <div id="test" style="margin-left: 10px;">
                                                    <span class="h6 mb-0">{{item}}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </b-col>
                            </b-row>
                            <b-row style="margin-top: 20px;">
                                <b-col>
                                    <b-button @click="choosePages({_id: ebook._id})" variant="success">Personalizar este e-book</b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import EbookPageBox from "./theme/EbookPageBox";
import service from "./../service";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import Multiselect from "vue-multiselect";
import { constants } from "fs";
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import { isIOS } from "mobile-device-detect";

export default {
  name: "Ebook",
  props: {
    isMine: false
  },
  data: function() {
    return {
      currentPage: 1,
      perPage: 24,
      totalPages: 1,
      selectedCategories: [],
      taggingSelected: null,
      includeExpress: true,
      includeAdvanced: true,
      loading: true,
      onlyIncludeAdvanced: false,
      modalShow: false,
      noTemplateUsed: false,
      searchId: "",
      isMobileScreen: isMobile,
      isIOS: isIOS,
      nextPageIndex: 1,
      me: undefined,
      pages: [],
      ebooks: [],
      ebookPrice: 27
    };
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    hotCategories() {
      let hotCategories = [];

      if (this.categoriesList && this.categoriesList.length) {
        for (let key in this.categoriesList) {
          if (this.categoriesList[key].hot) {
            hotCategories.push(this.categoriesList[key])
          }
        }
      }
      
      return hotCategories;
    }
  },
  created: function() {
    service.getEbooks().then(result => {
      this.ebooks = result.ebooks;
      this.loading = false;
    });

    service.getEbookPrice().then(result => {
      this.ebookPrice = result.ebookPrice;
    });


    this.modalShow = true;
    service.getMe().then(me => {
      if (!me.subscription.editionCount) {
        this.noTemplateUsed = true;
      }

      this.me = me;
    });

    this.currentPage = 1;
  },
  methods: {
    showModal() {
      this.showModal = true;
    },
    hideModal() {
      this.$refs["bv-modal-example"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["bv-modal-example"].toggle("#toggle-btn");
    },
    refreshData: function() {
      this.getTemplates();
    },
    choosePages: function(ebook) {
      let route = '/ebook/' + ebook._id + '/cover';
      this.$router.push(route);
    },
    getEbookPriceText: function() {
      if (this.ebookPrice == 19) {
        return ("Preço exclusivo para assinantes Premium. Para gerar e-books ilimitados, mude para o plano VIP.");
      } else if (this.ebookPrice == 0) {
        return ("Seu plano permite gerar e-books gratuitamente.");
        //return ("* Condição exclusiva para assinantes de planos semestrais e anuais.");
        return ("");
      } else {
        return ("Cada e-book custa R$27. Você pode ver todas as páginas e montar seu e-book antes de pagar.");
      }
    }
  },
  components: { EbookPageBox, VueBootstrapTypeahead, Spinner }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
.center-text {
  text-align: center !important;
}
.margin-extra {
  margin: 20px !important;
  width: unset !important;
}
</style>
